import React, { useState, useEffect, useRef } from "react";
import { doc, getDoc } from "firebase/firestore";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { db } from "../firebase/firebase";

export const Image = ({ title, smallImage, item }) => {
  const [urls, setUrls] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const firstImageRef = useRef(null); // 🔹 ใช้ ref เพื่อกดเปิดภาพอัตโนมัติ

  const getUrlsByThemeKey = async (themeKey) => {
    try {
      const urlRef = doc(db, "urlImages", themeKey);
      const docSnap = await getDoc(urlRef);

      if (docSnap.exists()) {
        console.log("URLs:", docSnap.data().urls);
        setUrls(docSnap.data().urls);
        setIsOpen(true);
      } else {
        console.log("No such document!");
        setUrls([]);
      }
    } catch (error) {
      console.error("Error fetching URLs:", error);
      setUrls([]);
    }
  };

  const handleClick = () => {
    if (item?.themeKey) {
      getUrlsByThemeKey(item.themeKey);
    }
  };

  // 🔹 เปิดรูปแรกอัตโนมัติเมื่อ urls โหลดเสร็จ
  useEffect(() => {
    if (isOpen && urls.length > 0) {
      setTimeout(() => {
        firstImageRef.current?.click();
      }, 100); // ใช้ setTimeout ป้องกัน race condition
    }
  }, [isOpen, urls]);
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <div
          onClick={() => handleClick()}
          style={{ cursor: "pointer" }}
          className="hover-text"
        >
          <h4>{title}</h4>
        </div>
        <img
          src={smallImage}
          className="img-responsive"
          alt={title}
          onClick={() => handleClick()}
          style={{ cursor: "pointer" }}
        />
      </div>

      {/* 🔹 แสดงรูปทั้งหมด แต่กดเปิดแค่รูปแรก */}
      {isOpen && urls.length > 0 && (
        <PhotoProvider>
          {urls.map((url, index) => (
            <PhotoView key={index} src={process.env.REACT_APP_URL_IMAGE + url}>
              {index === 0 && (
                <img
                  src={process.env.REACT_APP_URL_IMAGE + url}
                  alt="Hidden Trigger"
                  ref={firstImageRef}
                  style={{ display: "none" }}
                />
              )}
            </PhotoView>
          ))}
        </PhotoProvider>
      )}
    </div>
  );
};
